import { IBaseEntity } from '../common';

export enum PDFGeneratorOutputFormat {
  PDF = 'pdf',
  PNG = 'png',
  BOTH = 'both',
}

export const PDFGeneratorPageSize = {
  LETTER: 'Letter',
  LEGAL: 'Legal',
  TABLOID: 'Tabloid',
  LEDGER: 'Ledger',
  A0: 'A0',
  A1: 'A1',
  A2: 'A2',
  A3: 'A3',
  A4: 'A4',
  A5: 'A5',
  A6: 'A6',
} as const;

export type PDFGeneratorPageSize =
  (typeof PDFGeneratorPageSize)[keyof typeof PDFGeneratorPageSize];

export interface IPDFGeneratorOptions {
  page_size?: PDFGeneratorPageSize;
  margins?: {
    top?: string;
    right?: string;
    bottom?: string;
    left?: string;
  };
  landscape?: boolean;
  print_background?: boolean;
  scale?: number;
}

export interface IPDFGeneratorConfig extends IBaseEntity {
  enable: boolean;
  queue_limit: number;
  timeout_ms: number;
  max_retries: number;
  retry_delay_ms: number;
  cleanup_days: number;
  output_format: PDFGeneratorOutputFormat;
  default_options: IPDFGeneratorOptions;
}
